module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-medium-385c136e.woff";